import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {DevilsCrossRoad} from "../../DevilsCrossRoad";
import {DevilsCrossRoadGameMode} from "../../server/DevilsCrossRoadGameMode";
import {gsap} from "gsap";


export class ActivateFsAnimations implements SimplePresentation {
    name: string = "ActivateFsAnimations";

    shouldRun(): boolean {
        return (DevilsCrossRoad.model.data.mode !== DevilsCrossRoadGameMode.FREESPIN && DevilsCrossRoad.model.data.nextMode === DevilsCrossRoadGameMode.FREESPIN);
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl = gsap.timeline();

        tl.add(DevilsCrossRoad.freespinUnlockAreas.activateAnimation("top"));

        tl.add(() => controller.finish());
    }
}